import React, { useEffect, useState } from 'react'
import { Container, Dropdown, Badge} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from '../auth/useAuth'
import Notifications from './Notifications'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
// import socketClient from "socket.io-client"
import { User } from 'lucide-react'

export default function MenuTechnical({roles}) {
	const { t } = useTranslation()
	const { clientauth, logoutClient } = useAuth()

    const dispatch = useDispatch()

    const {notifications} = useSelector(state=>state.notifications)

	const [showCanvas, setShowCanvas] = useState(false)

	// useEffect(() => {
	// 	const socket = socketClient(process.env.REACT_APP_SOCKET_ADDRESS, {withCredentials:  true})
	// 	socket.on("newNotification", data => {
	// 		if (data.employee === clientauth?.employee) {
	// 			dispatch({
	// 				type: 'NOTIFICATION_ADD_SOCKET_SUCCESS',
	// 				payload: data
	// 			})
	// 		}
	// 	})
	// }, [dispatch, clientauth])

  	return (
		<Container className="d-none d-md-flex justify-content-end align-items-center">
			<div className='me-3'>{clientauth?.name}</div>
			<div className="me-3 position-relative cursor" onClick={() => setShowCanvas(true)}>
				<img src="/images/menus/bell-positivo.svg" alt={t('menus.bell')}/>
				{notifications?.length > 0 &&
					<Badge
						pill
						bg="primary"
						className="position-absolute top-0 start-100 translate-middle"
					>
						{notifications?.length}
					</Badge>
				}
			</div>
			<Dropdown className=''>
				<Dropdown.Toggle variant='drop' id="dropdown-basic" className='ms-auto'>
					<i className="fas fa-bars"></i>
				</Dropdown.Toggle>
				<Dropdown.Menu>
					{/* <Dropdown.Item as={Link} to={`/${t("url.technical.technical")}/${t("url.technical.profile")}`}><User size={16} className="me-2" /> {t('menus.profile')}</Dropdown.Item> */}
					<Dropdown.Item as={Link} to="/" onClick={logoutClient}><img src="/images/menus/logout.svg" alt={t('menus.logout')}/> {t('menus.logout')}</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
			<Notifications showCanvas={showCanvas} setShowCanvas={setShowCanvas}/>
		</Container>
	)
}